import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Auth
      "login": "Login",
      "register": "Register",
      "email": "Email",
      "password": "Password",
      "fullName": "Full Name",
      "phone": "Phone",
      "organizationName": "Organization Name",
      "role": "Role",
      "owner": "Owner",
      "manager": "Manager",
      "tenant": "Tenant",
      "logout": "Logout",
      
      // Navigation
      "dashboard": "Dashboard",
      "portfolios": "Portfolios",
      "properties": "Properties",
      "units": "Units",
      "tenants": "Tenants",
      "leases": "Leases",
      "payments": "Payments",
      "maintenance": "Maintenance",
      "vendors": "Vendors",
      "insights": "Revenue Insights",
      "community": "Community",
      
      // Dashboard
      "totalProperties": "Total Properties",
      "totalUnits": "Total Units",
      "occupancyRate": "Occupancy Rate",
      "occupiedUnits": "Occupied Units",
      "vacantUnits": "Vacant Units",
      "totalTenants": "Total Tenants",
      "monthlyRevenue": "Monthly Revenue",
      "outstandingPayments": "Outstanding Payments",
      "overduePayments": "Overdue Payments",
      "pendingMaintenance": "Pending Maintenance",
      
      // Actions
      "add": "Add",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "view": "View",
      "search": "Search",
      "filter": "Filter",
      "export": "Export",
      
      // Portfolio
      "addPortfolio": "Add Portfolio",
      "portfolioName": "Portfolio Name",
      "description": "Description",
      
      // Property
      "addProperty": "Add Property",
      "propertyName": "Property Name",
      "address": "Address",
      "city": "City",
      "propertyType": "Property Type",
      "residential": "Residential",
      "commercial": "Commercial",
      "mixed": "Mixed",
      
      // Unit
      "addUnit": "Add Unit",
      "unitNumber": "Unit Number",
      "unitType": "Unit Type",
      "size": "Size (sqm)",
      "monthlyRent": "Monthly Rent",
      "status": "Status",
      "occupied": "Occupied",
      "vacant": "Vacant",
      "maintenance": "Maintenance",
      "floor": "Floor",
      "bedrooms": "Bedrooms",
      "bathrooms": "Bathrooms",
      
      // Tenant
      "addTenant": "Add Tenant",
      "tenantName": "Tenant Name",
      "nationalId": "National ID",
      "nationality": "Nationality",
      "emergencyContact": "Emergency Contact",
      "riskScore": "Risk Score",
      
      // Lease
      "addLease": "Add Lease",
      "startDate": "Start Date",
      "endDate": "End Date",
      "securityDeposit": "Security Deposit",
      "paymentDay": "Payment Day",
      "active": "Active",
      "expired": "Expired",
      "terminated": "Terminated",
      
      // Payment
      "amount": "Amount",
      "dueDate": "Due Date",
      "paidDate": "Paid Date",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "overdue": "Overdue",
      "partial": "Partial",
      "markAsPaid": "Mark as Paid",
      "paymentMethod": "Payment Method",
      
      // Maintenance
      "addMaintenanceRequest": "Add Maintenance Request",
      "title": "Title",
      "priority": "Priority",
      "category": "Category",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "urgent": "Urgent",
      "pending": "Pending",
      "assigned": "Assigned",
      "inProgress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "assignToVendor": "Assign to Vendor",
      "markAsCompleted": "Mark as Completed",
      
      // Insights
      "underpriced": "Underpriced",
      "overpriced": "Overpriced",
      "vacancyRisk": "Vacancy Risk",
      "currentRent": "Current Rent",
      "suggestedRent": "Suggested Rent",
      "reasoning": "Reasoning",
      
      // Community
      "announcement": "Announcement",
      "event": "Event",
      "culturalTip": "Cultural Tip",
      "general": "General",
      "addPost": "Add Post",
      "content": "Content"
    }
  },
  ar: {
    translation: {
      // Auth
      "login": "تسجيل الدخول",
      "register": "التسجيل",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "fullName": "الاسم الكامل",
      "phone": "الهاتف",
      "organizationName": "اسم المنظمة",
      "role": "الدور",
      "owner": "مالك",
      "manager": "مدير",
      "tenant": "مستأجر",
      "logout": "تسجيل الخروج",
      
      // Navigation
      "dashboard": "لوحة التحكم",
      "portfolios": "المحافظ",
      "properties": "العقارات",
      "units": "الوحدات",
      "tenants": "المستأجرين",
      "leases": "العقود",
      "payments": "المدفوعات",
      "maintenance": "الصيانة",
      "vendors": "الموردين",
      "insights": "رؤى الإيرادات",
      "community": "المجتمع",
      
      // Dashboard
      "totalProperties": "إجمالي العقارات",
      "totalUnits": "إجمالي الوحدات",
      "occupancyRate": "معدل الإشغال",
      "occupiedUnits": "وحدات مشغولة",
      "vacantUnits": "وحدات شاغرة",
      "totalTenants": "إجمالي المستأجرين",
      "monthlyRevenue": "الإيرادات الشهرية",
      "outstandingPayments": "المدفوعات المتأخرة",
      "overduePayments": "مدفوعات متأخرة",
      "pendingMaintenance": "صيانة معلقة",
      
      // Actions
      "add": "إضافة",
      "edit": "تعديل",
      "delete": "حذف",
      "save": "حفظ",
      "cancel": "إلغاء",
      "view": "عرض",
      "search": "بحث",
      "filter": "تصفية",
      "export": "تصدير",
      
      // Portfolio
      "addPortfolio": "إضافة محفظة",
      "portfolioName": "اسم المحفظة",
      "description": "الوصف",
      
      // Property
      "addProperty": "إضافة عقار",
      "propertyName": "اسم العقار",
      "address": "العنوان",
      "city": "المدينة",
      "propertyType": "نوع العقار",
      "residential": "سكني",
      "commercial": "تجاري",
      "mixed": "مختلط",
      
      // Unit
      "addUnit": "إضافة وحدة",
      "unitNumber": "رقم الوحدة",
      "unitType": "نوع الوحدة",
      "size": "المساحة (متر مربع)",
      "monthlyRent": "الإيجار الشهري",
      "status": "الحالة",
      "occupied": "مشغولة",
      "vacant": "شاغرة",
      "maintenance": "صيانة",
      "floor": "الطابق",
      "bedrooms": "غرف النوم",
      "bathrooms": "الحمامات",
      
      // Tenant
      "addTenant": "إضافة مستأجر",
      "tenantName": "اسم المستأجر",
      "nationalId": "رقم الهوية",
      "nationality": "الجنسية",
      "emergencyContact": "جهة اتصال طوارئ",
      "riskScore": "درجة المخاطرة",
      
      // Lease
      "addLease": "إضافة عقد",
      "startDate": "تاريخ البدء",
      "endDate": "تاريخ الانتهاء",
      "securityDeposit": "التأمين",
      "paymentDay": "يوم الدفع",
      "active": "نشط",
      "expired": "منتهي",
      "terminated": "ملغى",
      
      // Payment
      "amount": "المبلغ",
      "dueDate": "تاريخ الاستحقاق",
      "paidDate": "تاريخ الدفع",
      "paid": "مدفوع",
      "unpaid": "غير مدفوع",
      "overdue": "متأخر",
      "partial": "جزئي",
      "markAsPaid": "تحديد كمدفوع",
      "paymentMethod": "طريقة الدفع",
      
      // Maintenance
      "addMaintenanceRequest": "إضافة طلب صيانة",
      "title": "العنوان",
      "priority": "الأولوية",
      "category": "الفئة",
      "low": "منخفضة",
      "medium": "متوسطة",
      "high": "عالية",
      "urgent": "عاجلة",
      "pending": "معلقة",
      "assigned": "معينة",
      "inProgress": "قيد التنفيذ",
      "completed": "مكتملة",
      "cancelled": "ملغاة",
      "assignToVendor": "تعيين لمورد",
      "markAsCompleted": "تحديد كمكتمل",
      
      // Insights
      "underpriced": "أقل من السعر",
      "overpriced": "أعلى من السعر",
      "vacancyRisk": "خطر الشغور",
      "currentRent": "الإيجار الحالي",
      "suggestedRent": "الإيجار المقترح",
      "reasoning": "السبب",
      
      // Community
      "announcement": "إعلان",
      "event": "حدث",
      "culturalTip": "نصيحة ثقافية",
      "general": "عام",
      "addPost": "إضافة منشور",
      "content": "المحتوى"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;